import { Preservation } from "@/Features";
import { Modal } from "@monolith-forensics/monolith-ui";
import { FC } from "react";
import { EditPreservationForm } from "../Forms";

interface EditPreservationModalProps {
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
  preservation: Preservation;
}
export const EditPreservationModal: FC<EditPreservationModalProps> = ({
  open,
  onClose,
  onEdit,
  preservation,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <EditPreservationForm
        onSubmit={onEdit}
        onCancel={onClose}
        defaultFormData={{
          uuid: preservation?.uuid,
          case_id: preservation?.case.id || 0,
          acquisition_id: preservation?.acquisition?.id || null,
          method_id: preservation?.method?.id || null,
          status_id: preservation?.status?.id || null,
          contact_id: preservation?.contact?.id || null,
          linked_contact: preservation?.contact
            ? {
                value: preservation.contact.id,
                label: preservation.contact.name,
                data: preservation.contact,
              }
            : null,
          evidence_id: preservation?.evidence?.id || null,
          linked_evidence: preservation?.evidence
            ? {
                value: preservation.evidence.id,
                label: preservation.evidence.evidence_number,
                data: preservation.evidence,
              }
            : null,
          start_date: preservation?.start_date || null,
          end_date: preservation?.end_date || null,
          description: preservation?.description || "",
          name: preservation?.name || "",
          trigger_date: preservation?.trigger_date || null,
          trigger_type_id: preservation?.trigger_type?.id || null,
        }}
      />
    </Modal>
  );
};
